import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=2a8c2e69&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports